import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { formatUSD, type Totals } from "../utils/acvRcv";

interface ManifestCTAProps {
  totals: Totals;
}

export default function ManifestCTA({ totals }: ManifestCTAProps) {
  const gap = formatUSD(totals.gap);
  return (
    <div className="rounded-2xl border border-border bg-gradient-to-br from-primary/8 via-card to-card p-8 md:p-10 text-center">
      <div className="text-[11px] font-semibold uppercase tracking-wide text-primary mb-2">
        Close the gap before you need to
      </div>
      <h2 className="font-editorial text-2xl md:text-3xl tracking-tight">
        Your <span className="text-rose-600 tabular-nums">{gap}</span> gap is what insurers won't pay
        without proof.
      </h2>
      <p className="text-sm md:text-base text-muted-foreground mt-3 max-w-xl mx-auto leading-relaxed">
        Manifest builds your home inventory with AI — snap photos, forward receipts, get an
        insurance-ready PDF. Documentation is the only thing that turns ACV into RCV in a real claim.
      </p>
      <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
        <Link
          to="/login"
          className="inline-flex items-center justify-center gap-1.5 rounded-lg bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground hover:opacity-90 transition-opacity"
        >
          Start your free inventory <ArrowRight className="h-4 w-4" />
        </Link>
        <Link
          to="/blog/acv-vs-rcv-insurance"
          className="inline-flex items-center justify-center gap-1.5 rounded-lg border border-border bg-card px-6 py-3 text-sm font-semibold hover:bg-muted/40 transition-colors"
        >
          Read the full ACV vs RCV guide
        </Link>
      </div>
      <div className="text-[11px] text-muted-foreground mt-4">
        7-day free trial · No credit card required
      </div>
    </div>
  );
}
